export default "__VITE_ASSET__3dluqMpw__"